import { Returns } from "modules/returns";

const ReturnsPage = () => {
  return <Returns />;
};

export default ReturnsPage;
